<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode"></ParseForm>
      </template>    
      <template>
        <ParseList ref='plmn' :formId="formItems.plmn.formId" :formParams="formItems.plmn.formObj" :opCode="opCode" :Title="formItems.plmn.title"
          :maxLength="formItems.plmn.maxLength" :minLength="formItems.plmn.minLength" :funcClick="bindClickInterface">
        </ParseList>
      </template>
      <PlmnProfileList ref='profileId' :getCheckedDatas='getCheckedList' ></PlmnProfileList>
      <SnssaiProfileIds ref='snssaiProfileIds' :getCheckedDatas='getSnssaiCheckedList' ></SnssaiProfileIds>
      <DnnProfileList ref='dnnProfileIds' :getCheckedDatas='getDnnCheckedList' ></DnnProfileList>
      <AmDataProfileIds ref='amDataProfileId' :getCheckedDatas='getAmdataCheckedList' ></AmDataProfileIds>
    </div>
  </div>
</template>
<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import PlmnProfileList from "./PlmnProfileList";
import SnssaiProfileIds from "./SnssaiProfileIds";
import DnnProfileList from "./DnnProfileList";
import AmDataProfileIds from "./AmDataProfileIds";
import CustomDialog from '../../../../common/CustomDialog';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ParseList from '../../../util/parseFormNew/ParseList';
import ajaxUrl from "../../../data/ajaxUrl";

export default {
  name: "ModProfileForm",
  components: {
    ParseForm,
    PlmnProfileList,
    SnssaiProfileIds,
    DnnProfileList,
    AmDataProfileIds,
    CustomDialog,
    ParseList,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      if (this.$refs.plmn) {
        if (!this.$refs.plmn.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const plmn = this.$refs.plmn.getDatas();
        map.set('plmnInfos', plmn);
      }  
      console.log(map);
      return map;
    },
    UpdatePlmnInfosConfig(json) {
      return json.map((item)=>{
        if (item.id === "plmnInfos") {
          return {
            ...item,
            "attrList": [
              {
                "modifyShow":false,
                "type":"",
                "batch_hidden":true,
                "tempFlag":false,
                "changeClick":false,
                "groupBy":item.groupBy,
                "id":"count",
                "couldMod":false,
                "showName":"plmn个数",
                "hidden":true,
                "name":"count",
                "value":"",
                "uiIndex":item.uiIndex,
                "require":false,
                "couldBatchMod":false
              },
              {
                "modifyShow":false,
                "type":"",
                "batch_hidden":true,
                "tempFlag":false,
                "changeClick":false,
                "groupBy":item.groupBy,
                "id":"list",
                "couldMod":false,
                "showName":"plmn",
                "hidden":true,
                "name":"list",
                "value":"",
                "uiIndex":item.uiIndex,
                "require":false,
                "attrList":	item.attrList,
                "couldBatchMod":false
              }
            ]
          }
        }
        else {
          return item;
        }
      })
    },
    getJson(ne, checkedDatas, callback) {  
      this.ne = ne;
      const plmnObjList = checkedDatas[0].plmnInfos.list
      .filter((item) => { return item !== "" })
      .map((item) => {
        return {
          amDataProfileId: item.amDataProfileId,
          dftDnnProfileIds: item.dftDnnProfileIds,
          dftSnssaiProfileIds: item.dftSnssaiProfileIds,
          dnnProfileIds: item.dnnProfileIds,
          isHome: item.isHome,
          profileId: item.profileId,
          snssaiProfileIds: item.snssaiProfileIds,
        }
      })
              console.log("456",plmnObjList)

      const checkedRecord = {
        ...checkedDatas[0],
                plmnInfos: {
          count: plmnObjList.length,
          list: plmnObjList,
        },
      };
      console.log('checkedRecord',checkedRecord);
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.usersubJson, params).then(response => {
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }       
        const jsonObj = this.UpdatePlmnInfosConfig(response.data.resultVal);
 console.log('jsonObj',jsonObj);
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(jsonObj, checkedRecord);
        console.log('resultMap',resultMap);

        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        this.formItems.plmn.formObj = resultMap.get(this.formItems.plmn.modelName); 
       // this.formItems.plmn.formObj = this.formItems.plmn.formObj[0].attrList; 
        console.log('22',this.formItems.plmn.formObj);

        callback(response);
      });      
    },
    saveProfile(ne, callback) {
      const formData = this.getDatas();      
      if (formData) {    
        const plmnList = formData.get("plmnInfos").list;
         const plmnList2 = [];
console.log("plmnList",plmnList)
        for (let i=0; i<formData.get("plmnInfos").count; i++) {
          var snssaiProfileIdsInt=[];
          const snssai = plmnList[i].snssaiProfileIds.split(',').filter((item) => { return parseInt(item) !== "" });        
          snssai.forEach(element => {
          snssaiProfileIdsInt.push(parseInt(element));
        });
          var dftSnssaiInt=[];
          dftSnssaiInt.push(parseInt(plmnList[i].dftSnssaiProfileIds));

          var dnnProfileIdsInt=[];
          const dnn = plmnList[i].dnnProfileIds.split(',').filter((item) => { return parseInt(item) !== "" });        
          dnn.forEach(element => {
          dnnProfileIdsInt.push(parseInt(element));
        });
          var dftDnnInt=[];
          dftDnnInt.push(parseInt(plmnList[i].dftDnnProfileIds));

          plmnList2.push({
            "profileId": plmnList[i] ? parseInt(plmnList[i].profileId) : 0, 
            "isHome": plmnList[i] ? parseInt(plmnList[i].isHome) : 0,
            "snssaiProfileIds": snssaiProfileIdsInt,
            "dftSnssaiProfileIds": dftSnssaiInt,
            "dnnProfileIds": dnnProfileIdsInt,
            "dftDnnProfileIds": dftDnnInt,
            "amDataProfileId": parseInt(plmnList[i].amDataProfileId),
          })
        }

        const params = { 
          vo: {
            "profileId": parseInt(formData.get("profileId")),
            "profileName": formData.get("profileName"),
            "plmnInfos": 
              plmnList2
            , 
          }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        console.log("params",params);

        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
    showProfileList() {
      this.$refs.profileId.qryList(this.ne);
      this.$refs.profileId.show();
      this.$refs.snssaiProfileIds.qryList(this.ne);
      this.$refs.snssaiProfileIds.show();
      this.$refs.dnnProfileIds.qryList(this.ne);
      this.$refs.dnnProfileIds.show();
      this.$refs.amDataProfileId.qryList(this.ne);
      this.$refs.amDataProfileId.show();
    }, 
    getAmdataCheckedList(list) {   
      this.selectedKeys = [...list];      
      let value = '';   
      let range = '';
      for(let i=0; i<list.length; i++) {
        value += list[i];
        range += list[i];
        if(i != list.length-1) {
          value += ',';
          range += '|';
        }
      }
      if(this.$refs.plmn) {
        this.$refs.plmn.setData(this.$refs.plmn.getClickIndex(),'amDataProfileId', value);
      } 
    },
    getCheckedList(list) {   
      this.selectedKeys = [...list];      
      let value = '';   
      let range = '';
      for(let i=0; i<list.length; i++) {
        value += list[i];
        range += list[i];
        if(i != list.length-1) {
          value += ',';
          range += '|';
        }
      }

      if(this.$refs.plmn) {
               console.log("plmnvalue:",value)

        this.$refs.plmn.setData(this.$refs.plmn.getClickIndex(),'profileId', value);
        this.plmnId=value;

      } 
    },
    getSnssaiCheckedList(list) {   
      this.selectedKeys = [...list];      
      let value = '';   
      let range = '';
      for(let i=0; i<list.length; i++) {
        value += list[i];
        range += list[i];
        if(i != list.length-1) {
          value += ',';
          range += '|';
        }
      }
      const validate = {
        required: [true, '此处不可空白'],
        regex: [`^(${range})$`, '该值必须是关联网络切片模板ID中的一项。'],
      };
      console.log("Snssaivalue:",value)
      if(this.$refs.plmn) {
        this.$refs.plmn.setData(this.$refs.plmn.getClickIndex(),'snssaiProfileIds', value);
        this.snssaiId=value;
       // this.$refs.plmn.setValidate('dftSnssaiProfileIds', validate);
      } 
    },
    getDnnCheckedList(list) {   
      this.selectedKeys = [...list];      
      let value = '';   
      let range = '';
      for(let i=0; i<list.length; i++) {
        value += list[i];
        range += list[i];
        if(i != list.length-1) {
          value += ',';
          range += '|';
        }
      }
      const validate = {
        required: [true, '此处不可空白'],
        regex: [`^(${range})$`, '该值必须是关联DNN模板ID中的一项。'],
      };
      if(this.$refs.plmn) {
        this.$refs.plmn.setData(this.$refs.plmn.getClickIndex(),'dnnProfileIds', value);
       // this.$refs.plmn.setValidate('dftDnnProfileIds', validate);
      } 
    },
    onclickDnnProfileLst() {
      this.$refs.dnnProfileIds.qryList(this.ne,this.snssaiId);
      this.$refs.dnnProfileIds.show();
    },
    onclickPlmnProfileLst() {
      this.$refs.profileId.qryList(this.ne);
      this.$refs.profileId.show();
    },
    onclickSnssaiProfileLst() {
      this.$refs.snssaiProfileIds.qryList(this.ne,this.plmnId);
      this.$refs.snssaiProfileIds.show();
    },
    onclickAmdataProfileLst() {
      this.$refs.amDataProfileId.qryList(this.ne,this.plmnId);
      this.$refs.amDataProfileId.show();
    },
  },
  computed: {
    bindClickInterface() { 
      this.funcMap = new Map();      
      this.funcMap.set('dnnProfileIds', () => { this.onclickDnnProfileLst(); });      
      this.funcMap.set('profileId', () => { this.onclickPlmnProfileLst(); });      
      this.funcMap.set('snssaiProfileIds', () => { this.onclickSnssaiProfileLst(); });      
      this.funcMap.set('amDataProfileId', () => { this.onclickAmdataProfileLst(); });     
      return this.funcMap;
    }
  },
  data() {
    return {      
      ne: null,
      plmnId:null,
      snssai:null,
      snssaiId:null,
      selectedKeys: [],
      funcMap: null,
      formItems: {
        basic: {
          formId: "ProfileModProfileInfo",
          modelName: "basic",
          formObj: null,
        },
                plmn: {
          title: "PLMN",
          formId: "ProfileModPlmnInfo",
          modelName: "plmn", 
          formObj: null,
          maxLength: 4,
          minLength: 1,
        },
      },  
      opCode: "mod",
      msgId: "28689",
    };
  },  
  beforeDestroy() {
  }
};
</script>

